/**
 * MIA Refresh Service
 * Singleton service to manage refresh events for MIA AI feature lists
 * Matches Flutter's MiaRefreshService exactly
 */

import { reactive } from "vue";
import { MiaRefreshType } from "../types";

/**
 * Refresh service state
 */
const state = reactive({
  // Listeners for each feature type
  listeners: {
    [MiaRefreshType.SUMMARY]: [],
    [MiaRefreshType.FLASH_CARDS]: [],
    [MiaRefreshType.QBANK]: [],
    [MiaRefreshType.PROBLEM_SOLVING]: [],
  },
});

/**
 * MIA Refresh Service - Singleton
 * Matches Flutter's MiaRefreshService API
 */
export const miaRefreshService = {
  /**
   * Subscribe to refresh events for a specific feature type
   * @param {string} type - MiaRefreshType
   * @param {Function} callback - Callback function to call on refresh
   * @returns {Function} Unsubscribe function
   */
  subscribe(type, callback) {
    if (!state.listeners[type]) {
      state.listeners[type] = [];
    }

    state.listeners[type].push(callback);

    // Return unsubscribe function
    return () => {
      const index = state.listeners[type].indexOf(callback);
      if (index > -1) {
        state.listeners[type].splice(index, 1);
      }
    };
  },

  /**
   * Trigger a refresh for a specific feature type
   * @param {string} type - MiaRefreshType
   */
  refresh(type) {
    if (!state.listeners[type]) return;

    console.log(`[MiaRefreshService] Triggering refresh for: ${type}`);

    state.listeners[type].forEach((callback) => {
      try {
        callback();
      } catch (e) {
        console.error("[MiaRefreshService] Callback error:", e);
      }
    });
  },

  /**
   * Trigger refresh for all feature types
   */
  refreshAll() {
    Object.keys(state.listeners).forEach((type) => {
      this.refresh(type);
    });
  },

  /**
   * Clear all listeners (typically not needed)
   */
  dispose() {
    Object.keys(state.listeners).forEach((type) => {
      state.listeners[type] = [];
    });
  },
};
